// @flow
import styled from 'styled-components';
import SVGIcon from '~/core/icons/svg-icons';
import { Temperature } from '~/components/widgets';

export const InfoBar = styled.ul`
    display: flex;
    height: ${props => props.theme.infoBarHeight};
    margin-bottom: 0;
    margin-top: 0;
    /* we also define the max-height to be sure it does not use more space than allowed*/
    max-height: ${props => props.theme.infoBarHeight};
    overflow: hidden;
    padding-right: 1em;
    justify-content: flex-end;
    align-items: center;
`;

export const Item = styled.li`
    align-items: center;
    display: flex;
    height: ${props => props.theme.infoBarHeight};
    justify-content: center;
`;

export const Icon = styled(SVGIcon)`
    height: 2em;
    margin-bottom: 0.3em;
    margin-right: 5px;
    width: 2em;
`;

export const Temp = styled(Temperature)`line-height: ${props => props.theme.infoBarHeight};`;



// WEBPACK FOOTER //
// ./src/components/widgets/info-bar/styles.js